import { useGetBusinessAccountsQuery } from '@energy-stacks/fleet/feature-business-accounts-data';

export const useBusinessAccounts = () => {
  return useGetBusinessAccountsQuery();
};
